export default {
  l: {
    add: "Agregar",
    addCashDesk: "Agregar Caja",
    addChannel: "Agregar Canal",
    addCity: "Agregar Ciudad",
    addChannelClientCompositionMapping: "Agregar Mapeo de Composición de Cliente del Canal",
    addChannelHotelRateCodeMapping: "Agregar Mapeo de Código de Tarifa del Hotel del Canal",
    addChannelHotelRoomTypeMapping: "Agregar Mapeo de Tipo de Habitación del Hotel del Canal",
    addCountry: "Agregar País",
    addCreditCardType: "Agregar Tipo de Tarjeta de Crédito",
    addGeneralJournal: "Agregar Diario General",
    addJournalAccountType: "Agregar Tipo de Cuenta del Diario",
    addJournalBatch: "Agregar Lote del Diario",
    addJournalTemplate: "Agregar Plantilla del Diario",
    addRoomStatus: "Agregar Estado de la Habitación",
    addRoomType: "Agregar Tipo de Habitación",
    adminCode: "Código Admin",
    adminName: "Nombre Admin",
    adminNameAscii: "Nombre Admin ASCII",
    adminType: "Tipo Admin",
    amountAfterDiscount: "Cantidad después del descuento",
    backOffice: "Back Office",
    bankAccount: "Cuenta Bancaria",
    bankAccountId: "ID de Cuenta Bancaria",
    bookingSource: "Fuente de Reservas",
    cancel: "Cancelar",
    cancelConfirmation: "Confirmación de Cancelación",
    capital: "Capital",
    cashDesk: "Caja",
    channel: "Canal",
    channelAgencyCode: "Código de Agencia del Canal",
    channelClientCompositionMapping: "Mapeo de Composición de Cliente del Canal",
    channelHotelRateCodeMapping: "Mapeo de Código de Tarifa del Hotel del Canal",
    channelHotelRoomTypeMapping: "Mapeo de Tipo de Habitación del Hotel del Canal",
    channelId: "ID del Canal",
    channelManager: "Gestor de Canales",
    channelRateCode: "Código de Tarifa del Canal",
    channelRoomType: "Tipo de Habitación del Canal",
    channelRoomTypeCode: "Código de Tipo de Habitación del Canal",
    city: "Ciudad",
    cityAlt: "Ciudad Alternativa",
    cityAscii: "Ciudad ASCII",
    code: "Código",
    country: "País",
    countryId: "ID del País",
    credit: "Crédito",
    creditCard: "Tarjeta de Crédito",
    creditCardType: "Tipo de Tarjeta de Crédito",
    customer: "Cliente",
    customerNo: "N.º de Cliente",
    customerLedger: "Libro Mayor de Clientes",
    dashboard: "Tablero",
    defaultBookingSource: "Fuente de Reservas Predeterminada",
    defaultMarketSegment: "Segmento de Mercado Predeterminado",
    delete: "Eliminar",
    deleteConfirmation: "Confirmación de Eliminación",
    density: "Densidad",
    description: "Descripción",
    documentNo: "N.º de Documento",
    documentType: "Tipo de Documento",
    edit: "Editar",
    editCashDesk: "Editar Caja",
    editChannel: "Editar Canal",
    editCity: "Editar Ciudad",
    editChannelClientCompositionMapping: "Editar Mapeo de Composición de Cliente del Canal",
    editChannelHotelRateCodeMapping: "Editar Mapeo de Código de Tarifa del Hotel del Canal",
    editChannelHotelRoomTypeMapping: "Editar Mapeo de Tipo de Habitación del Hotel del Canal",
    editCountry: "Editar País",
    editCreditCardType: "Editar Tipo de Tarjeta de Crédito",
    editGeneralJournal: "Editar Diario General",
    editJournalAccountType: "Editar Tipo de Cuenta del Diario",
    editJournalBatch: "Editar Lote del Diario",
    editJournalTemplate: "Editar Plantilla del Diario",
    editRoomStatus: "Editar Estado de la Habitación",
    editRoomType: "Editar Tipo de Habitación",
    entryNo: "N.º de Entrada",
    failed: "Fallido",
    frontOffice: "Front Office",
    generalJournal: "Diario General",
    hotelAgency: "Agencia de Hotel",
    hotelAgencyGroup: "Grupo de Agencia de Hotel",
    hotelClient: "Cliente del Hotel",
    hotelRate: "Tarifa del Hotel",
    hotelRoomType: "Tipo de Habitación del Hotel",
    iso2Code: "Código ISO2",
    journalAccountNo: "N.º de Cuenta del Diario",
    journalAccountType: "Tipo de Cuenta del Diario",
    journalBatch: "Lote del Diario",
    journalTemplate: "Plantilla del Diario",
    latitude: "Latitud",
    lineNo: "N.º de Línea",
    longitude: "Longitud",
    mandatory: "Obligatorio",
    marketSegment: "Segmento de Mercado",
    masterData: "Datos Maestros",
    name: "Nombre",
    new: "Nuevo",
    no: "No",
    numericCode: "Código Numérico",
    officialStateName: "Nombre Oficial del Estado",
    originalAmount: "Monto Original",
    population: "Población",
    populationProper: "Población Apropiada",
    postingDate: "Fecha de Registro",
    rate: "Tarifa",
    ranking: "Clasificación",
    roomStatus: "Estado de la Habitación",
    roomType: "Tipo de Habitación",
    sameName: "Mismo Nombre",
    save: "Guardar",
    simpleMapsCityId: "ID de Ciudad de SimpleMaps",
    successful: "Exitoso",
    timezone: "Zona Horaria",
    yes: "Sí",
    variance: "Varianza",
    mealDate: "Fecha de Comida",
    cannotModifySelectedData: "No se puede modificar los datos seleccionados",
    betaTesting: "Prueba Beta",
    foodAndBeverage: "Alimentos y Bebidas",
    allDepartments: "Todos los Departamentos",
    selectAllDepartments: "Seleccionar Todos los Departamentos",
    currCollectionType: "Tipo de Cobranza Actual",
    changeCollectionType: "Cambiar Tipo de Cobranza",
    addItem: "Agregar {item}",
    currentItem: "Actual {item}",
    changeItem: "Cambiar {item}",
    startOperatingHour: "Inicio de Horas de Operación",
    endOperatingHour: "Hora de Cierre",
    salesByTableLabelReport: "Informe de etiquetas de ventas por mesa",
    label: "Etiqueta",
    edcMachineIntegration: "Integración de Máquina EDC",
    enableEdcMachine: "Activar máquina EDC",
    edcMode: "Modo EDC",
    edcModeAlways: "Usar siempre EDC",
    edcModePrompt: "Indicar al cajero que elija",
    edcAgentUrl: "URL del Agente Sentec",
    edcAgentUrlPlaceholder: "Dejar vacío para usar la URL de pos.agent",
    edcAgentUrlHint: "Vuelve a la URL pos.agent si no está configurada",
    edcAgentToken: "Token de Agente Sentec",
    edcAgentTokenPlaceholder: "Dejar vacío para usar el token pos.agent",
    edcAgentTokenHint: "Anula el token pos.agent cuando se establece",
    edcVendor: "Proveedor EDC",
    edcComPort: "Puerto COM",
    edcComPortPlaceholder: "p. ej. COM3",
    edcTestConnection: "Probar conexión",
    edcConnected: "Conectado",
    edcFailed: "Fallido",
    edcEnterAgentUrlFirst: "Por favor, ingresa primero la URL del Agente Sentec.",
    edcPayment: "Pago EDC",
    edcInvoiceAmountRemaining: "Cantidad de factura restante",
    edcUserPayment: "Pago del usuario",
    edcTerminalWillReceive: "El terminal recibirá: {amount} ({currency} unidades menores)",
    edcChange: "Cambiar",
    edcRemainingPayment: "Pago restante",
    edcPressPayToInitiate: "Presiona Pagar para iniciar la transacción EDC",
    edcWaitingForCard: "Esperando tarjeta...",
    edcSecondsRemaining: "{seconds}s restantes",
    edcCancel: "Cancelar",
    edcTransactionApproved: "Transacción Aprobada",
    edcTransactionFailed: "Transacción Fallida",
    edcRetry: "Reintentar",
    edcPayViaEdc: "Pagar por EDC",
    edcConfirm: "Confirmar",
    edcCard: "Tarjeta",
    edcAuthCode: "Código de Autenticación",
    edcTraceNumber: "Rastro #",
    edcTerminal: "Terminal",
    edcTransactionDeclined: "Transacción rechazada",
    edcConnectionFailed: "Error al conectar con el terminal EDC",
    edcTotalPaymentAlreadyEqual: "Pago total ya igual al monto de la factura.",
    postingGroupFollowsClient: "No hay grupo de publicación de cliente establecido - el grupo de publicación sigue al cliente",
    lockClientPostingGroup: "Bloquear grupo de publicación de cliente",
  },
  m: {
    dimensionValueNotInDimension: "Ese valor pertenece a otra dimensión. Elija un valor de la dimensión seleccionada.",
    dimensionSetupOwnerChanged: "El registro seleccionado cambió. La dimensión no se guardó: vuelva a abrir la configuración e inténtelo de nuevo.",
    saveFirstBeforeDimensionSetup: "Guarde este registro primero y luego configure sus dimensiones.",
    fieldIsRequired: "Este campo es obligatorio",
    confirmCancel: "¿Estás seguro de que deseas cancelar {f}? Este proceso no se puede deshacer.",
    confirmDelete: "¿Está seguro de que desea eliminar {f}? Este proceso no se puede deshacer.",
    err: {
      betLen: "{f} debe tener entre {v1} y {v2} caracteres",
      cantXWhileOffline: "No se puede {x} mientras está desconectado",
      ge: "{f} debe ser mayor o igual a {v}",
      gt: "{f} debe ser mayor que {v}",
      le: "{f} debe ser menor o igual a {v}",
      lt: "{f} debe ser menor que {v}",
      maxLen: "{f} debe tener un máximo de {v} caracteres",
      maxVal: "El valor máximo de {f} es {v}{x}",
      minLen: "{f} debe tener un mínimo de {v} caracteres",
      minMaxVal: "El valor de {f} debe estar entre {v1}{x} y {v2}{x}",
      minVal: "El valor mínimo de {f} es {v}{x}",
      number: "{f} debe ser un número, positivo o negativo",
      numeric: "{f} debe consistir solo en números",
      req: "{f} es requerido",
      duplicate: "{f} {v} ya existe",
    },
    confirmLogout: "¿Estás seguro de que quieres cerrar sesión?",
    confirmFlushSiteData: "¿Estás seguro de que quieres borrar los datos del sitio? Esto cerrará tu sesión y recargará la página.",
    successFlushSiteData: "Datos del sitio eliminados. Se cerrará tu sesión y la página se recargará.",
    invalidPhoneNumber: "El número de teléfono no es válido, solo se permiten números y +",
    invalidDateOfBirth: "La fecha de nacimiento no es válida. Por favor, usa el formato AAAA-MM-DD.",
  },
  common: {
    add: "Agregar",
    cancel: "Cancelar",
    description: "Descripción",
    delete: "Eliminar",
    title: "Título",
    save: "Guardar",
    faq: "Preguntas Frecuentes",
    contact: "Contáctanos",
    tos: "Términos de Servicio",
    policy: "Política de Privacidad",
    articleFlavour: "Sabor del Artículo",
    articleGroupName: "Grupo de Artículos",
    showFlavour: "Mostrar Sabor",
    hide: "Esconder",
    created: "Creado",
    updated: "Actualizado",
    deleted: "Eliminado",
  },
  agent: {
    availableDownloads: "Descargas disponibles",
    checkVersion: "Verificar versión",
    sentecAgentConfigSettings: "Configuración del Agente Sentec",
    sentecAgentAccounts: "Cuentas del Agente Sentec (V2)",
    sentecAgentAccountsDesc: "Cuentas del Agente Sentec para el uso del protocolo de comunicación WebSocket",
    pleaseCheckDeviceConfigurationSentecAgent: "Por favor, verifique si el dispositivo, la configuración y el servicio Sentec Agent están configurados correctamente y en funcionamiento",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "Por favor, verifique si el dispositivo y la configuración están configurados correctamente. Si todo está correcto, asegúrese de que el servidor de la interfaz PMS esté en funcionamiento",
    viewDownloads: "Ver descargas",
  },
  board: {
    titlePlaceholder: "Enter a title for this card",
    deleteDescription: "Are you sure you want to delete this card?",
    editCard: "Edit Card",
    deleteCard: "Delete Card",
    state: {
      TODO: "TO DO",
      INPROGRESS: "INPROGRESS",
      TESTING: "TESTING",
      DONE: "DONE",
    },
  },
  menu: {
    rateManagement: "Rate Management",
    reservation: "Reservation",
    reservationNew: "New",
    reservationList: "List",
    frontOffice: "Front Office",
    guestTitle: "Guest Title",
    guestDocumentType: "Guest Document Type",
    manageHotel: "Hotel",
    hotel: "Hotel",
    hotelList: "List",
    hotelCategory: "Hotel Category",
    hotelChain: "Hotel Chain",
    marketSegment: "Market Segment",
    rooms: "Rooms",
    currency: "Currency",
    search: "Search (press \"ctrl + /\" to focus)",
    logout: "Logout",
    flushSiteData: "Eliminar datos del sitio",
    switchToFO: "Cambiar a Recepción (PMS)",
    switchToFinance: "Cambiar a Finanzas",
    profile: "Profile",
    blank: "Blank Page",
    pages: "Pages",
    others: "Others",
    email: "Email",
    chat: "Chat",
    todo: "Todo",
    board: "Task Board",
    users: "Users",
    usersList: "List",
    usersEdit: "Edit",
    ecommerce: "Ecommerce",
    ecommerceList: "Products",
    ecommerceProductDetails: "Product Details",
    ecommerceOrders: "Orders",
    ecommerceCart: "Cart",
    auth: "Auth Pages",
    authLogin: "Signin / Login",
    authRegister: "Signup / Register",
    authVerify: "Verify Email",
    authForgot: "Forgot Password",
    authReset: "Reset Password",
    errorPages: "Error Pages",
    errorNotFound: "Not Found / 404",
    errorUnexpected: "Unexpected / 500",
    utilityPages: "Utility Pages",
    utilityMaintenance: "Maintenance",
    utilitySoon: "Coming Soon",
    utilityHelp: "FAQs / Help",
    levels: "Menu Levels",
    disabled: "Menu Disabled",
    docs: "Documentation",
    feedback: "Feedback",
    support: "Support",
    dashboard: "Tablero",
    tables: "Mesas",
    orderHistories: "Historiales de Pedidos",
    all: "Todo",
    closed: "Cerrado",
    open: "Abierto",
    loading: "Cargando...",
    loadingPleaseWait: "Cargando... Por favor espere",
    workingDate: "Fecha de Trabajo",
    deletedSentOrders: "Órdenes Enviadas Eliminadas",
    deletedOrderPayments: "Pagos de Órdenes Eliminados",
    transferOrderHistory: "Historial de Transferencia de Órdenes",
    closedDays: "Días Cerrados",
    screens: "Pantallas",
    generalSettings: "Configuración General",
    masterData: "Datos Maestros",
    outlet: "Punto de Venta",
    generalSetup: "Configuración General",
    parameter: "Parámetro",
    table: "Mesa",
    articleProductType: "Tipo de Producto del Artículo",
    article: "Artículo",
    articleGroup: "Grupo de Artículos",
    articleGroupSetup: "Configuración del Grupo de Artículos",
    articleGroupOutletSetup: "Configuración del Grupo de Artículos del Punto de Venta",
    articleFlavourGroup: "Grupo de Sabores de Artículos",
    articleFlavour: "Sabor del Artículo",
    articleFlavourGroupArticleGroupSetup: "Configuración del Grupo de Sabores del Grupo de Artículos",
    collectionCategory: "Categoría de Colección",
    collectionType: "Tipo de Colección",
    collectionIdentificationGroup: "Grupo de Identificación de Colección",
    collectionIdentification: "Identificación de Colección",
    collectionTypeOutletSetup: "Configuración del Tipo de Colección del Punto de Venta",
    price: "Precio",
    discount: "Descuento",
    printer: "Impresora",
    screen: "Pantalla",
    agent: "Agente",
    banquet: "Banquete",
    banquetGroupList: "Lista de Grupos de Banquetes",
    banquetReservationList: "Lista de Reservas de Banquetes",
    banquetReservationCalendar: "Calendario de Reservas de Banquetes",
    reports: "Informes",
    masterAccount: "Cuenta Maestra",
    incomeAudit: "Auditoría de Ingresos",
    outletStatus: "Estado del Punto de Venta",
    manageNfcBracelet: "Gestionar Pulsera NFC",
    taxInterfaceIntegrationLog: "Registro de Integración de Interfaz de Impuestos",
    workingDay: "Día Laboral",
    index: "Índice",
    printerType: "Printer Type",
    quickOrder: "Pedido rápido",
    mealTimeSetup: "Configuración de Hora de Comida",
    tableReservation: "Reserva de Mesa",
    breakfastRegistration: "Registro de Desayuno",
    mealRegistration: "Registro de Comidas",
    roomBreakfastRegistration: "Registro de Desayuno en la Habitación",
    roomLunchRegistration: "Registro de Almuerzo en la Habitación",
    roomDinnerRegistration: "Registro de Cena en la Habitación",
    banquetLunchRegistration: "Registro para el almuerzo del banquete",
    banquetDinnerRegistration: "Registro para la cena del banquete",
    itemLoan: "Préstamo de Artículos",
    courseStage: "Etapa del platillo",
    waiter: "Camarero",
    intercompanyMapping: "Mapeo Interempresarial",
    guestProfiles: "Perfiles de Invitados",
    fbMenuOrderRequest: "Solicitud de pedido del menú F&B",
    fbMenuConfiguration: "Configuración del Menú F&B",
    tableLabelManagement: "Gestión de etiquetas de mesas",
    package: "Paquete",
    maintenanceRequest: "Solicitud de Mantenimiento",
    captainOrder: "Orden del Capitán",
  },
  localColumns: {
    dimensionCode: "Código de Dimensión",
    dimensionName: "Nombre de Dimensión",
    dimensionValueCode: "Código de Valor de Dimensión",
    dimensionValueName: "Nombre de Valor de Dimensión",
    expenseDimensions: "Dimensiones de Gasto",
    costDimensions: "Dimensiones de Costo",
    dashboardWithItem: "Tablero {item}",
    top10ItemsSoldWithItem: "Top 10 Artículos Vendidos - {item}",
    openDay: "Día de puertas abiertas",
    closeDay: "Día de puertas cerradas",
    hostURLIPAddress: "URL de host/dirección IP",
    roomRevenueBreakdown: "Desglose de Ingresos de Habitaciones",
    inHouseList: "Lista de Huéspedes",
    itemLoan: "Préstamo de Artículos",
    maintenanceRequestReport: "Reporte de Solicitud de Mantenimiento",
    to: "a",
    unknown: "Desconocido",
    topProduct: "Producto Destacado",
    hour: "Hora",
    salesRevenue: "Ingresos por Ventas",
    transactions: "Transacciones",
    averageTransactions: "Transacciones Promedio",
    averageSales: "Ventas Promedio",
    quantitySold: "Cantidad Vendida",
    averagePrice: "Precio Promedio",
    totalOrders: "Total de Pedidos",
    totalSales: "Ventas Totales",
    averageOrderAmount: "Monto Promedio por Pedido",
    topProductName: "Producto Más Vendido",
    topProductRevenue: "Ingresos del Producto Más Vendido",
    averageBillSize: "Tamaño Promedio de Factura",
    topBeverageArticle: "Bebida Más Vendida",
    topFoodArticle: "Comida Más Vendida",
    currentStock: "Stock Actual",
    costPerUnit: "Costo por Unidad",
    last30DaysSalesQuantity: "Cantidad de Ventas en los Últimos 30 Días",
    daysUntilOutOfStock: "Días Hasta Agotar Stock",
    averageDaysPerOrder: "Promedio de Días por Pedido",
    revenuePercentage: "Porcentaje de Ingresos",
    reOrderLevel: "Nivel de Reorden",
    discountDescription: "Descripción del descuento",
    discountCount: "Conteo de Descuentos",
    totalDiscountAmount: "Total de Descuento",
    // PMS-322: the Discount Report's guest-facing (gross) discount. Never "VAT" (R11): the
    // figure includes service charge, and on an exempt line contains no VAT at all.
    discountAmountWithTax: "Monto de Descuento (Incl. Impuestos y Cargo por Servicio)",
    totalRevenueExcludingTax: "Ingresos Totales Sin Impuestos",
    articleGroupName: "Nombre del Grupo de Artículos",
    creditBalanceAmount: "Saldo de Crédito",
    totalUsedBalance: "Saldo Total Usado",
    currentBalance: "Saldo Actual",
    allowOverLimit: "Permitir Exceso",
    foodRevenue: "Ingresos de Alimentos",
    beverageRevenue: "Ingresos de Bebidas",
    costAccount: "Cuenta de Costos",
  },
  button: {
    add: "Add",
  },
  collectionType: {
    oneCollectionTypePerCategoryPerOutlet: "Por favor, asegúrese de que cada tienda tenga al menos un tipo de colección para cada categoría de colección. Para la categoría de colección PULSERA, cada tienda debe tener exactamente un tipo de colección",
  },
  chat: {
    online: "Usuarios en línea ({count})",
    addChannel: "Agregar canal",
    channel: "Canal | Canales",
    message: "Mensaje",
  },
  email: {
    compose: "Redactar correo",
    send: "Enviar",
    subject: "Asunto",
    labels: "Etiquetas",
    emptyList: "Lista de correos vacía",
    inbox: "Bandeja de entrada",
    sent: "Enviados",
    drafts: "Borradores",
    starred: "Destacados",
    trash: "Papelera",
    work: "Trabajo",
    invoice: "Factura",
    notValid: "Correo electrónico no válido",
  },
  todo: {
    addTask: "Agregar tarea",
    tasks: "Tareas",
    completed: "Completado",
    labels: "Etiquetas",
  },
  dashboard: {
    activity: "Actividad",
    weeklySales: "Ventas semanales",
    sales: "Ventas",
    recentOrders: "Pedidos recientes",
    sources: "Fuentes de tráfico",
    lastweek: "vs la semana pasada",
    orders: "Pedidos",
    customers: "Clientes",
    tickets: "Tickets de soporte",
    viewReport: "Ver informe",
    totalPaidOrders: "Total de Pedidos Pagados",
    totalAmount: "Monto Total",
    grandTotal: "Gran Total",
    totalQty: "Cantidad Total",
    totalGuests: "Total de Huéspedes",
    totalQuickOrders: "Total de Pedidos Rápidos",
    foodTotalAmount: "Monto Total de Alimentos",
    foodTotalQty: "Cantidad Total de Alimentos",
    beverageTotalAmount: "Monto Total de Bebidas",
    beverageTotalQty: "Cantidad Total de Bebidas",
    othersTotalAmount: "Monto Total de Otros",
    othersTotalQty: "Cantidad Total de Otros",
    tobaccoTotalAmount: "Monto Total de Tabaco",
    tobaccoTotalQty: "Cantidad Total de Tabaco",
    totalCovers: "Total de cubiertos (Clientes atendidos)",
    averageSpendPerGuest: "Gasto promedio por cliente",
    averageTransactionValue: "Valor promedio de transacción",
    averageTableTurnTime: "Tiempo promedio de rotación de mesa",
    seatingCapacity: "Capacidad de asientos",
    totalItemsSold: "Total de Artículos Vendidos",
    totalTransactions: "Total de transacciones",
    summaryMetrics: "Métricas de resumen",
    potentialCoversPerMealtime: "Cubiertos potenciales por horario de comida",
    serviceCharge: "Cargo por servicio ({percent}% de los ingresos)",
    vatRevenue: "IVA ({percent}% de los ingresos)",
    netSales: "Ventas netas (Excl. impuestos y servicio)",
    totalTaxes: "Total de impuestos",
    dateRangeTo: "Rango de fechas: {s} a {e}",
    topThreeItemsSold: "Tres Artículos Más Vendidos",
    topDiscounts: "Descuentos Principales",
    outletHours: "Horario del Establecimiento:",
    breakfast: "Desayuno",
    lunch: "Almuerzo",
    dinner: "Cena",
    allDayDining: "Servicio Todo el Día",
    potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} cubiertos ({seating_capacity} asientos x {potential_turns_per_mealtime} turnos)",
    occupancyRateDesc: "{occupancy_rate} % ({total_covers} invitados / {total_seats} asientos x {potential_turns_per_mealtime} turnos potenciales en {days_config} días)",
    mealTime: "Horario de Comidas",
    allRevenueExcludingComplimentary: "*Todos los ingresos, excluyendo los artículos de cortesía.",
    complimentaryExcluded: "*Cortesía excluida.",
    allRevenueAllDayIncludeComplimentary: "Todos los ingresos provienen del servicio de comidas todo el día e incluyen servicios complementarios.",
    assumedTableTurnTime: "Tiempo de Rotación Asumido",
    totalItemIncludingComplimentaryItems: "Total de artículos incluyendo artículos de cortesía",
    totalTransactionsIncludingComplimentary: "Total de transacciones incluyendo cortesías",
    totalBaseAmountExcludingComplimentaryItems: "Total base sin artículos de cortesía",
    totalCoversNumberOfGuestIncludingComplimentary: "Total de cubiertos (número de invitados) incluyendo cortesías",
    averageSpendPerGuestExcludingComplimentaryItemsOrServices: "Gasto promedio por huésped, excluyendo artículos o servicios complementarios.",
    averageTransactionValueExcludingComplimentaryItemsOrServices: "Valor promedio de transacción, excluyendo artículos o servicios complementarios.",
    averageTableTurnoverTimeComplimentaryExcluded: "Tiempo promedio de rotación de mesas, excluyendo cortesías",
    percentageOfAvailableSeatCapacityUsedByGuests: "El porcentaje de capacidad de asientos disponible que fue realmente utilizada por los huéspedes",
    totalOrdersIncludeComplimentary: "Total de pedidos incluye cortesía.",
    totalPaidOrdersIncludeComplimentary: "Total de pedidos pagados incluye complementarios.",
    clickForDetailsBreakdown: "Haz clic para detalles / desglose",
    totalNumberOfSeatsAvailableForGuests: "Total de asientos disponibles para invitados",
    percentageOfAvailableSeatCapacityActuallyUsedByGuests: "El porcentaje de capacidad de asientos disponible que fue realmente utilizada por los huéspedes",
    totalServiceChargeExcludingComplimentaryItems: "Cargo total del servicio, excluyendo artículos de cortesía",
    totalVatRevenueExcludingComplimentaryItems: "Total de IVA, excluyendo artículos de cortesía",
    totalNetSalesExcludingComplimentaryItems: "Ventas Netas Totales, excluyendo artículos de cortesía",
    totalTaxesExcludingComplimentaryItems: "Total impuestos, excluyendo artículos de cortesía",
    totalNetSalesIncludingComplimentaryItems: "Ventas Netas Totales, incluyendo artículos de cortesía",
    totalAmountExcludingComplimentaryItems: "Total a pagar, excluyendo artículos de cortesía",
    applyFilter: "Aplicar Filtro",
  },
  usermenu: {
    profile: "Perfil",
    signin: "Iniciar sesión",
    dashboard: "Tablero",
    signout: "Cerrar sesión",
  },
  error: {
    notfound: "Página no encontrada",
    other: "Ocurrió un error",
    failedUpdateOrder: "Error al actualizar el pedido",
    noPermission: "No tienes permiso para realizar esta acción",
  },
  check: {
    title: "Establecer nueva contraseña",
    backtosign: "Volver a iniciar sesión",
    newpassword: "Nueva contraseña",
    button: "Establecer nueva contraseña e iniciar sesión",
    error: "El enlace de acción no es válido",
    verifylink: "Verificando enlace...",
    verifyemail: "Verificando dirección de correo electrónico...",
    emailverified: "¡Correo verificado! Redirigiendo...",
  },
  forgot: {
    title: "¿Olvidaste tu contraseña?",
    subtitle: "Ingrese la dirección de correo electrónico de su cuenta y le enviaremos un enlace para restablecer su contraseña.",
    email: "Correo electrónico",
    button: "Solicitar restablecimiento de contraseña",
    backtosign: "Volver a iniciar sesión",
  },
  login: {
    title: "Iniciar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    button: "Iniciar sesión",
    orsign: "O inicia sesión con",
    forgot: "¿Olvidaste tu contraseña?",
    noaccount: "¿No tienes una cuenta?",
    create: "Crea una aquí",
    error: "La combinación de correo electrónico / contraseña no es válida",
  },
  register: {
    title: "Crear cuenta",
    name: "Nombre completo",
    email: "Correo electrónico",
    password: "Contraseña",
    passwordRetype: "Vuelve a escribir la contraseña",
    button: "Crear cuenta",
    orsign: "O regístrate con",
    agree: "Al registrarte, aceptas los",
    account: "¿Ya tienes una cuenta?",
    signin: "Iniciar sesión",
  },
  order: {
    cantCorrectPaymentBecauseTaxInterfaceStatusIsValid: "No se puede corregir el pago porque el estado de la interfaz fiscal es válido",
    cantDeletePaymentBecauseTaxInterfaceStatusIsValid: "No se puede eliminar el pago porque el estado de la interfaz fiscal es válido",
    redirectReceiptVerificationURL: "URL de Redirección del Recibo",
    deleteSentOrder: "Eliminar orden enviada",
    closeOrder: "Cerrar Pedido",
    closeOrderConfirmation: "¿Está seguro de que desea cerrar este pedido?",
    pastDateClientCompositionWarning: "Este pedido es de una fecha de trabajo cerrada. Su factura de venta y sus pagos en Finanzas también se moverán al nuevo cliente.",
  },
  parameter: {
    stickyLabelPrintSettings: "Configuración de impresión de etiquetas adhesivas",
    maxPreviewBillPrintCount: "Cantidad máxima de vista previa de impresión de facturas",
    maxPreviewBillPrintCountReached: "Límite de impresión excedido: ha alcanzado la cantidad máxima permitida de vistas previas de impresión de facturas.",
    maxPreviewBillPrintCountLimit0: "Ingrese '0' para sin límite",
    numberSeriesAndVATExemption: "Número, Serie y Exención de IVA",
    vatRegNo: "Número de registro de IVA",
    minNo: "Número mínimo",
    snNo: "Número de serie",
    checkNoSeries: "Verificar serie de números",
    receiptNoSeries: "Serie de números de recibo",
    permitNo: "Nº de Permiso (STN S/N)",
    accreditedNo: "Número acreditado",
    isEnableExemptVAT: "Está habilitada la exención de IVA",
    isCardNumberNotMandatory: "Número de tarjeta no obligatorio",
    isCardNameNotMandatory: "Nombre en la tarjeta no obligatorio",
    isCardTraceNoNotMandatory: "Número de seguimiento no obligatorio",
    isDeleteSentOrderReasonNotMandatory: "Eliminar motivo del pedido no obligatorio",
    isCancelOrderReasonNotMandatory: "Cancelar motivo del pedido no obligatorio",
    isPrintCancelOrderDoc: "Imprimir documento de cancelación de pedido al eliminar pedido enviado",
    splitBillByItem: "Allow Split Bill by Item",
    enableTips: "Habilitar propinas",
    enableTipsHint: "Capturar propinas del cliente (Efectivo/Tarjeta) en el diálogo de Pago",
    isPrintBillOnQuickOrder: "Imprimir factura",
    isSendFoodOnQuickOrder: "Enviar pedido de tipo de producto alimenticio",
    isSendBeverageOnQuickOrder: "Enviar pedido de tipo de producto de bebida",
    isSendOthersOnQuickOrder: "Enviar pedido de otros tipos de productos",
    isSendTobaccoOnQuickOrder: "Enviar pedido de tipo de producto de tabaco",
    showGuestSignatureFieldInPreviewBill: "Mostrar campo de firma del huésped en la vista previa de la factura",
    showRoomNoFieldInPreviewBill: "Mostrar campo de número de habitación en la vista previa de la factura",
    showTipFieldInPreviewBill: "Mostrar campo de propina en la vista previa de la factura",
    font: "Fuente",
    textBold: "Texto en negrita",
    sendOrderPrintSettings: "Enviar configuración de impresión de pedidos",
    amountOfBillToPrintOnProcessingPayment: "Cantidad de copias de la factura al procesar el pago",
    isMultiplePaymentGroupedByType: "Pagos múltiples agrupados por tipo de pago",
    billPrintShowGuestPaymentAmountOnCash: "Mostrar el monto del pago del huésped en pagos en efectivo",
    billPrintLogoWidth: "Ancho del logo (en puntos)",
    applyDiscountAndAllowance: "Aplicar descuento y bonificación",
    discountArticle: "Mapa de este artículo",
    discountAndAllowance: "Descuento y Bonificación",
    applyingDiscountAndAllowancesWill: "Aplicar Descuento y Bonificación activará",
    activateTheDiscountTotalFeature: "Activar la función de Total de Descuento",
    generateDiscountRevenueLinesForBoth: "Generar líneas de ingresos por descuento tanto para",
    perItemDiscounts: "Descuentos por artículo",
    totalDiscounts: "Descuentos totales (a nivel de pedido)",
    theDiscountTotalWillBeMappedToTheSelectedArticle: "El Total de Descuento se asignará al artículo seleccionado",
    defaultItem: "Predeterminado {item}",
    billPrintSettings: "Configuración de impresión de facturas",
    wrapText: "Texto ajustado",
    defaultPrinter: "Impresora predeterminada",
    fontSize: "Tamaño de fuente (en puntos)",
    topMargin: "Margen Superior (en puntos)",
    leftMargin: "Margen Izquierdo (en puntos)",
    rightMargin: "Margen derecho (en puntos)",
    bottomMargin: "Margen Inferior (en puntos)",
    lineOffset: "Desplazamiento de línea (en puntos)",
    hideHotelNameInBillPrint: "Ocultar nombre del hotel en la factura",
    allowDeleteSentItems: "Permitir eliminar elementos enviados",
    showBraceletAsCollectionType: "Mostrar Pulsera como Tipo de Colección",
    headerText1: "Texto de Encabezado 1",
    headerText2: "Texto de Encabezado 2",
    footerText1: "Texto de pie 1",
    footerText2: "Texto del pie 2",
    salesCreditMemoSeries: "Serie de Notas de Crédito de Ventas",
    showGuestNameInSendOrder: "Mostrar el nombre del huésped en el envío del pedido",
    allowZeroCover: "Permitir cobertura cero",
    layoutCSalesInvoiceStatement: "Declaración de factura de ventas del diseño C",
    serialNo: "Nº de Serie",
    stnSn: "STN S/N",
    showManualOrNumber: "Mostrar manual o número (efectivo y tarjeta)",
    showPackageOrderDetailPrice: "Mostrar precio del detalle del paquete",
    allowPackageMemberDiscount: "Permitir descuento en artículos miembros del paquete",
    packageGroupName: "Nombre del grupo de paquetes",
    birZCounterSeries: "BIR Z Counter Series",
    hideTaxInLayoutCommonD: "Ocultar IVA y Cargo por Servicio",
    hideTaxInLayoutCommonDHint: "Solo para Diseño Común D (Camboyano)",
    billPrintCombineTaxLines: "Combinar impuesto e impuesto adicional en una línea",
    billPrintCombineTaxLinesHint: "Imprime todas las líneas de impuestos, excepto el cargo por servicio, en una sola línea",
    billOperatorName: "Nombre del operador (Operado por)",
    billOperatorNameHint: "Para Layout Common C: se imprime bajo el nombre del hotel. Déjelo vacío para no imprimir nada",
    useMenuTags: "Usar Etiquetas de Menú",
    billShowRoomName: "Mostrar nombre de la sala en lugar del número en la factura",
    askPinOnDeleteOrVoid: "Pedir PIN al eliminar pedidos enviados o anular",
  },
  printer: {
    identifyThisDeviceAsX: "Identificar este dispositivo como {x}",
    unassignThisDeviceFromX: "Desasignar este dispositivo de {x}",
    overrideAndAssignThisDeviceAsX: "Sobrescribir el dispositivo asignado y establecer este dispositivo como {x}",
    thisDeviceIsX: "Este dispositivo es {x}",
    testPrint: "Prueba de impresión",
    testPrintContent: "Contenido de prueba",
    testPrintSettings: "Configuración de impresión",
    sendTestPrint: "Enviar impresión de prueba",
    resetToDefault: "Restablecer a predeterminado",
    testPrintSent: "Prueba de impresión enviada",
    testPrintFailed: "Error en la impresión de prueba",
    testPrintNoAgent: "No hay un host de SentecAgent o URL de impresora configurada para esta impresora",
  },
  printerType: {
    printerName: "Nombre de la impresora",
    paperWidth: "Ancho del papel (en mm)",
    paperHeight: "Altura del papel (en mm)",
    isSupportExternal: "¿Soporta externo?",
  },
  utility: {
    maintenance: "En mantenimiento",
  },
  outlet: {
    discountGuestActuallyReceives: "El huésped recibe realmente",
    discountUnaffectedPercentage: "descuento porcentual — sin cambios",
    discountUnaffectedRateUnchanged: "la tasa de impuestos de esta línea no cambia",
    discountImpactTotal: "Total",
    discountExemptionImpactIntro: "Algunos artículos seleccionados tienen un descuento por importe. Cambiar la exención de IVA cambia los impuestos de esas líneas, así que elija qué importe mantener.",
    discountKeepBaseColumn: "Descuento del huésped — si mantiene la base",
    discountKeepGuestColumn: "Descuento base — si mantiene el del huésped",
    discountKeepBaseOption: "Mantener los importes base — cambia el descuento que recibe el huésped",
    discountKeepGuestOption: "Mantener el descuento del huésped — se recalculan los importes base",
    discountClampedToBase: "limitado al importe base del artículo",
    discountClampWarning: "En las líneas limitadas no se puede mantener por completo el descuento del huésped: un descuento no puede superar el importe base del artículo.",
    discountImpactApply: "Aplicar",
    taxDeclaration: "Declaración de impuestos",
    vatExemptionNote: "Nota de exención de IVA",
    applyDiscountWithVATExemptionToOutletWithDisabledExemptVAT: "No se puede aplicar descuento con exención de IVA ya que la configuración de 'Habilitar exención de IVA' actualmente está configurada en falso.",
    exemptUnexemptVAT: "Exento / No exento de IVA",
    exemptVAT: "Exento de IVA",
    unExemptVAT: "No exento de IVA",
    noPriceSetup: "Configuración de precio no establecida",
    noPriceAssignedToThisArticleOnCurrentWorkingDateContinue: "No se ha asignado un precio a este artículo en la fecha de trabajo actual. ¿Continuar?",
    cantAddArticleBecauseNoPriceAssignedToThisArticleOnCurrentWorkingDateAndAllowManualPriceIsSetToFalse: "No se puede agregar el artículo porque no se ha asignado un precio a este artículo en la fecha de trabajo actual y la opción de permitir precio manual está desactivada.",
    cantModifySelectedTotalDiscount: "No se puede modificar el descuento total seleccionado",
    cantSelectSavedOrSentItemIfInGarnishMode: "No puedes seleccionar un artículo que ya ha sido enviado o guardado si el modo de adorno está activado",
    cantDeleteChildOfSentItem: "No se puede eliminar un artículo hijo de un artículo enviado sin eliminar su padre.",
    cantChangeQtySentItem: "No se puede cambiar la cantidad porque al menos uno de los artículos seleccionados ya fue enviado.",
    flavourCantAssignToChild: "No se puede asignar un sabor a un artículo hijo.",
    flavourItemAlreadySent: "El artículo ya fue enviado.",
    flavourNothingSelected: "No se ha seleccionado ningún artículo para asignar un sabor.",
    flavourOnlySingleParent: "El sabor solo se puede asignar a un artículo padre.",
    qtyChangeNoSelection: "No hay artículo ni guarnición seleccionados para aplicar el cambio de cantidad.",
    qtyChangeMultipleSelection: "Hay más de un artículo y/o guarnición seleccionados para aplicar el cambio de cantidad.",
    cantSendZeroPriceItems: "No se pueden enviar artículos con un precio total de 0 o menos.",
    itemsAlreadySent: "Uno o más de los artículos seleccionados ya fueron enviados.",
    noPrinterOrScreenConfigured: "No hay ninguna impresora o pantalla configurada para enviar este pedido.",
    parentNotSelectedForSend: "No se puede enviar un artículo hijo mientras su padre no esté seleccionado.",
    cantSendOrderWhileOffline: "No se puede enviar el pedido sin conexión.",
    packageMemberDiscountDisabled: "No se puede aplicar descuento a artículos miembros del paquete porque esta opción está deshabilitada en la configuración de parámetros de POS.",
    garnishNotApplicableForPackage: "La guarnición no es aplicable para artículos de paquete.",
    ignoredSetStageForPackage: "La etapa no es aplicable para artículos de paquete.",
    changePriceNotAllowedForPackage: "No se permite cambiar el precio para artículos de paquete.",
    processingOrder: "Procesando pedido",
    creatingQuickOrder: "Creando pedido rápido",
    creatingOrder: "Creando Pedido",
    createOrder: "Crear Pedido",
    createOrderForX: "Crear Pedido para reserva de mesa con el nombre del huésped {x}",
    itemAlreadySaved: "Artículo ya guardado",
    itemAlreadySent: "Artículo ya enviado",
    noItemToPay: "No hay artículos para pagar",
    failedToPrintTo: "Error al Imprimir en {x}",
    successToPrintTo: "Éxito al Imprimir en {x}",
    captainOrderIminNotThisDevice: "{x} es una impresora integrada de otro dispositivo, por lo que no se pudo imprimir allí la comanda.",
    captainOrderM7NeedsAgent: "{x} es un servidor de impresión en dispositivo sin agente asignado. Asígnele un agente para que las comandas puedan llegar.",
    captainOrderIminNotConnected: "No se pudo conectar con la impresora integrada de este dispositivo ({x}).",
    captainOrderIminStatusError: "La impresora integrada de este dispositivo ({x}) informó el estado {status}, por lo que no se imprimió la comanda.",
    retry: "Reintentar",
    invalidPaymentMethod: "Método de pago no válido",
    customerOrderX: "Pedido del cliente {x}",
    pleaseSelectItemsToSend: "Por favor, seleccione el/los artículo(s) para enviar",
    itemsRemovedFromTheList: "Artículo(s) eliminado(s) de la lista",
    missingInvoiceSeries: "Falta la serie de factura",
    cantChooseXForSplitPayment: "No se puede elegir {x} para el pago dividido",
    amountToPay: "Monto a pagar",
    amountToPayCantBeGreaterThanRemainingPayment: "El monto a pagar no puede ser mayor que el pago restante",
    amountToPayCantBeGreaterThanSplitRemainder: "El monto a pagar no puede ser mayor que lo que aún se debe en esta división",
    selectSplitPaymentFirst: "Seleccione una división antes de agregar un pago",
    fireX: "Disparar {x}",
    hold: "Mantener",
    setStage: "Establecer etapa",
    selectOutlet: "Seleccionar Sucursal",
    xPax: "{x} PAX",
    orderIDIsNotGenerated: "El ID del pedido aún no se ha generado",
    cantDeleteSentOrderWhileOffline: "No se puede eliminar el pedido enviado mientras está sin conexión",
    cancelOrderDocBillPrinterNotConfigured: "El documento de cancelación no se imprimió: no hay impresora de cuenta predeterminada configurada para este punto de venta.",
    labelPrinterNotConfigured: "La impresora de etiquetas no está configurada para este punto de venta. Configure una impresora de etiquetas en los ajustes de Parámetros POS.",
    orderType: "Tipo de Orden",
    dineIn: "Comer aquí",
    pickup: "Para llevar",
    labelPrinter: "Impresora de etiquetas",
    alsoPrintStickyLabel: "Imprimir también las etiquetas adhesivas",
    labelPrinterId: "ID de impresora de etiquetas",
    printLabel: "Imprimir etiqueta",
    noItemSelectedToPrintLabel: "No hay artículos seleccionados para imprimir etiquetas.",
    labelOnlyForSentItems: "Las etiquetas solo se pueden imprimir para artículos enviados.",
    cantPrintLabelClosedOrder: "No se pueden imprimir etiquetas para un pedido cerrado o cancelado.",
    cancelOrderDocOutletMissing: "No se puede imprimir: los elementos seleccionados no tienen información del punto de venta.",
    cancelOrderDocSingleOutletOnly: "No se puede imprimir entre varios puntos de venta — seleccione elementos de un solo punto de venta.",
    cancelOrderDocParameterNotFound: "No se puede imprimir: parámetro POS del punto de venta no encontrado.",
    cancelOrderDocNotEnabledForOutlet: "La impresión del documento de cancelación no está habilitada para este punto de venta.",
    discountTotal: "Descuento Total",
    noItem: "Sin Artículos",
    allSavedItemsAlreadyHaveDiscountApplied: "Todos los artículos guardados ya tienen el descuento aplicado",
    cantHaveMultipleDiscountTotal: "no se puede tener múltiples descuentos totales",
    maxDiscountToApply: "Descuento Máximo a Aplicar",
    cashReceived: "Efectivo Recibido",
    cashChange: "Cambio",
    outletType: "Tipo de local",
    roomService: "Servicio a la habitación",
    noItemSelectedToAssignVAT: "Ningún artículo seleccionado para asignar exención/no exención de IVA",
    exemptVATCantBeAppliedToFlavour: "La exención/no exención de IVA no se puede aplicar al sabor",
    unexemptVATForSelectedItem: "Esto removera la exención de IVA para el artículo seleccionado. ¿Está seguro?",
    unexemptVATForXItems: "Esto removera la exención de IVA para {x} artículos seleccionados. ¿Está seguro?",
    mixedVATSelection: "Seleccionó {x} artículo(s) sin exención de IVA y {y} artículo(s) que ya están exentos. Elija cómo desea proceder.",
    discountAppliesToNonExemptOnly: "El descuento se aplicará únicamente a los {x} artículo(s) sin exención de IVA: los {y} artículo(s) ya exentos no se modificarán.",
    discountSkippedLines: "Estos artículos no recibirán el descuento y quedarán sin cambios, porque no se permite un descuento manual en ellos: {items}",
    discountExemptProofsDiffer: "Los artículos seleccionados tienen evidencia de exención de IVA distinta (otro ID de PWD, ID de persona mayor o nota). Descontarlos juntos aplicaría la evidencia de un artículo a todos, así que aplique el descuento de uno en uno.",
    cantSetCourseStageOfChildWhileParentNotSelected: "No se puede establecer la etapa del curso del elemento hijo mientras su padre no esté seleccionado.",
    quantityLimitExceeded: "{name}: Se superó la cantidad máxima vendida por día ({limit}). Quedan {remaining}, por favor revisa la cantidad.",
    failedToSendToPrinterOrScreen: "Error al enviar el pedido a la impresora o pantalla de cocina. El pedido seguirá guardado.",
  },
  discount: {
    amountIsBaseTaxAdded: "El importe ingresado es un importe base. Los impuestos y el cargo por servicio se agregan cuando corresponde, por lo que el importe descontado del total puede ser mayor que el importe ingresado.",
    taxAndServiceChargeIncluded: "Impuestos y Cargo por Servicio Incluidos",
    taxIncludedMasterHint: "Predeterminado cuando el Tipo de Valor es Importe",
    isExemptVAT: "Está exento de IVA",
    exemptionProofType: "Comprobante de Exención de IVA",
    useExemptionNote: "Usar Nota",
    usePwdId: "Usar ID PWD",
    useSeniorCitizenId: "Usar ID de Adulto Mayor",
    pwdId: "ID PWD",
    seniorCitizenId: "ID de Adulto Mayor",
    pwdName: "Nombre PWD",
    seniorCitizenName: "Nombre del Adulto Mayor",
  },
  bill: {
    chosenPrinterIsAnotherDevicesHead: "La impresora \"{printer}\" es la impresora integrada de otro dispositivo y no puede imprimir desde aquí. Elija otra impresora en Configuración de impresión de cuenta.",
    vatRegNo: "Número de registro de IVA",
    minNo: "Número MIN",
    snNo: "Número de serie",
    check: "Verificar",
    receiptNo: "Número de recibo",
    guest: "Huésped",
    date: "Fecha",
    time: "Hora",
    table: "Mesa",
    waiter: "Camarero",
    preview: "VISTA PREVIA",
    copy: "COPIA",
    original: "ORIGINAL",
    officialReceipt: "RECIBO OFICIAL",
    receipt: "RECIBO",
    amountWithVAT: "Monto con IVA",
    lessVAT: "Menos IVA",
    amountWithoutVAT: "Monto sin IVA",
    subtotal: "Subtotal",
    permitNo: "Número de permiso",
    accreditedNo: "Número acreditado",
    posSystemProvider: "Proveedor del sistema POS",
    tin: "NIF / TIN",
    issued: "Emitido",
    billPreparedBy: "Factura preparada por",
    billPrintedAt: "Factura impresa en",
    payment: "Pago",
    paid: "Pagado",
    change: "Cambio",
    name: "Nombre",
    guestName: "Nombre del huésped",
    signature: "Firma",
    seniorCitizenId: "ID de adulto mayor",
    seniorCitizenName: "Nombre del adulto mayor",
    pwdId: "ID de persona con discapacidad",
    pwdName: "Nombre de la persona con discapacidad",
    operatedBy: "OPERADO POR",
    roomNo: "Número de habitación",
    accountNo: "Número de cuenta",
    description: "Descripción",
    qty: "Cantidad",
    price: "Precio",
    totalAmount: "Monto total",
    amountCharged: "Monto cobrado",
    taxDeclaration: "Declaración de impuestos",
    officialReceiptNote1: "Esto sirve como recibo oficial si",
    officialReceiptNote2: "pagado en efectivo y tarjeta de crédito",
    item: "Artículo",
    total: "Total",
  },
  price: {
    currentBasePrice: "Precio base actual",
    currentPPVATSetupPrice: "Precio actual de configuración de IVA por período",
    currentAGOVATSetupPrice: "Precio actual de configuración de IVA por grupo de artículos",
    currentExemptedVATSetupPrice: "Precio actual de configuración de IVA exento",
    vatPriceSetupCode: "Código de configuración de precio de IVA",
    vatAGOSetupCode: "Código de configuración de grupo de IVA",
    vatExemptedSetupCode: "Código de configuración de IVA exento",
    articleArticleGroupId: "ID de Grupo de Artículo Artículo",
    changeWillBeAppliedToNPricePeriods: "Los cambios se aplicarán a {n} períodos de precio",
    batchUpdateWarningNote: "Para actualizar los datos de precio, marque 'Actualizar precio' e ingrese un nuevo valor. Complete otros campos según sea necesario para aplicar las actualizaciones. Deje cualquier campo en blanco para mantenerlo igual que el actual.",
    showOnFbMenu: "Mostrar en menú de FB",
    batchShowOnFbMenu: "Visibilidad del Menú FB",
    bulkShowOnFbMenu: "Mostrar en menú QR",
    bulkHideFromFbMenu: "Ocultar del menú QR",
    subRecipe: "Subreceta",
    addSubRecipe: "Agregar Subreceta",
  },
  faq: {
    call: "¿Tienes otras preguntas? Por favor contáctanos ",
  },
  ecommerce: {
    products: "Productos",
    filters: "Filtros",
    collections: "Colecciones",
    priceRange: "Rango de precios",
    customerReviews: "Opiniones de los clientes",
    up: "y más",
    brand: "Marca",
    search: "Buscar producto",
    results: "Resultados ( {0} de {1} )",
    orders: "Pedidos",
    shipping: "Envío",
    freeShipping: "Envío gratis",
    inStock: "En stock",
    quantity: "Cantidad",
    addToCart: "Agregar al carrito",
    buyNow: "Comprar ahora",
    price: "Precio",
    about: "Acerca de este artículo",
    description: "Descripción",
    reviews: "Reseñas",
    details: "Detalles del producto",
    cart: "Carrito",
    summary: "Resumen del pedido",
    total: "Total",
    discount: "Descuento",
    subtotal: "Subtotal",
    continue: "Seguir comprando",
    checkout: "Pagar",
  },
  intercompanyMapping: {
    sourceHotel: "Hotel de Origen",
    targetHotel: "Hotel de Destino",
    sourceArticle: "Artículo de Origen",
    targetArticle: "Artículo de Destino",
    sourceArticleGroup: "Grupo de Artículos de Origen",
    targetArticleGroup: "Grupo de Artículos de Destino",
    asSource: "Como Origen",
    asTarget: "Como Destino",
    mapping: "Mapeo",
    intercompanyArticleMapping: "Mapeo de Artículos Interempresarial",
    intercompanyArticleGroupMapping: "Mapeo de Grupos de Artículos Interempresarial",
    checkTargetOutletStatus: "Mapeo Interempresarial: Verificar Estado del Punto de Destino",
    createIntercompanyMappingEntries: "Mapeo Interempresarial: Crear Entradas de Mapeo",
    productTypesToTransfer: "Tipos de Producto a Transferir",
    defaultPayment: "Pago predeterminado del destino",
    defaultComplimentaryPayment: "Pago complementario predeterminado del destino",
    defaultCollectionIdentification: "Identificación de cobro predeterminada del destino",
    defaultOutlet: "Punto de venta predeterminado del destino",
    defaultTable: "Mesa predeterminada del destino",
    sourceOutlet: "Punto de venta de origen",
    sourceArticleProductType: "Tipo de producto del artículo de origen",
    prefix: "Prefijo del destino",
    checkSourceOutletStatus: "Mapeo intercompañía: Verificar el estado del punto de venta de origen",
  },
  generalSetup: {
    printDeletedSentOrder: "Imprimir orden enviada eliminada",
    showNFCIconInToolbar: "Mostrar el ícono de NFC en la barra de herramientas",
    showQuickOrderIconInToolbar: "Mostrar ícono de pedido rápido en la barra de herramientas",
    showQuickOrderInMenu: "Mostrar Orden Rápida en el Menú",
    hideTableNumberInTableList: "Ocultar número de tabla en la lista de tablas",
    billCopyWording: "Redacción de la 'Copy' de la Factura",
    customerTaxIdentifierText: "Texto del identificador fiscal del cliente (predeterminado 'Customer PIN')",
    showValidityAcknowledgmentCertificateStatement: "Mostrar Declaración de Validez de Reconocimiento de Certificado",
    sendOrderToScreens: "Enviar orden a las pantallas",
    systemInfo: "Información del Sistema",
    systemName: "Nombre del Sistema",
    systemVatRegTin: "NIF IVA del Sistema (VAT REG TIN)",
    vatRegTin: "NIF IVA (VAT REG TIN)",
    systemAccrNo: "Nº de Acreditación del Sistema",
    accrNo: "Nº de Acreditación",
    dateIssued: "Fecha de Emisión",
    validUntil: "Válido hasta",
    systemAccrIssuedDate: "Fecha de Emisión de la Acreditación del Sistema",
    systemAccrValidUntil: "Acreditación del Sistema válida hasta",
    systemPtuNo: "Nº de PTU del Sistema",
    ptuNo: "Nº de PTU",
    systemAddress: "Dirección del Sistema",
    systemPtuIssuedDate: "Fecha de Emisión del PTU del Sistema",
    useMenuTags: "Usar etiquetas de menú",
  },
  articleGroupOutlet: {
    saveArticleGroupOutletBeforeAddingRevenueCenterMealTime: "Por favor, guarde esta configuración del Grupo de Artículos de Outlet antes de agregar un Centro de Ingresos de Configuración de Horarios de Comida",
    confirmRevenueCenterInternalUserChange: "Esta acción actualizará la configuración del centro de ingresos para el grupo de artículos seleccionado. Las transacciones existentes vinculadas a este grupo de artículos no impedirán el cambio. ¿Desea continuar?",
    confirmVATPostingGroupInternalUserChange: "Esta acción actualizará el grupo de contabilización del IVA para el grupo de artículos seleccionado. Las transacciones existentes vinculadas a este grupo de artículos no impedirán el cambio. ¿Desea continuar?",
    exemptedVATPostingGroup: "Grupo de contabilización de IVA exento",
  },
  tableReservation: {
    seats: "Asientos",
    cantReserveForDateBeforeTodayWorkingDate: "No se puede reservar para una fecha anterior a la fecha laboral de hoy",
    tableReservedFromXtoY: "Mesa reservada de {x} a {y}",
    cantEditCompleted: "No se puede editar una reservación de mesa completada",
    cantCancelCompleted: "No se puede cancelar una reservación de mesa completada",
    cantDeleteCompleted: "No se puede eliminar una reservación de mesa completada",
    cantEditCanceled: "No se puede editar una reservación de mesa cancelada",
    cantCancelCanceled: "No se puede cancelar una reservación de mesa cancelada",
  },
  breakfastRegistration: {
    breakfastRegistration: "Registro de Desayuno",
    outletClosed: "Outlet Cerrado",
    noGuest: "Sin invitado",
    allGuestRegistered: "Todos los invitados ya están registrados para esta habitación",
    selectedGuestAlreadyRegistered: "El invitado seleccionado ya está registrado",
    readingCard: "Leyendo Tarjeta",
    guestRegistered: "Invitado Registrado",
    readCard: "Leer Tarjeta",
    registerGuest: "Registrar Invitado",
    undoRegisterGuest: "Deshacer Registro de Invitado",
    chooseGuestToUnregister: "Por favor, elija un huésped para desregistrar",
    cantUnregisterWhosNotRegistered: "No se puede desregistrar a un huésped que no ha sido registrado.",
    roomNotFoundInList: "Habitación no encontrada en la lista.",
  },
  mealRegistration: {
    totalExpected: "Total esperado",
    totalActual: "Total real",
    totalVariance: "Varianza total",
    totalBanquetReservation: "Total de reserva de banquete",
    undoRegister: "Deshacer registro",
    numberOfGuest: "Número de invitados",
    expected: "Esperado",
    actual: "Real",
    cardOutsideBanquetWindow: "{status}: Guest stay ({guestCheckIn} - {guestCheckOut}) is outside banquet time ({banquetStart} - {banquetEnd}).",
  },
  reports: {
    includeComplimentary: "Incluir Complementario",
    showVATBreakdown: "Mostrar desglose del IVA",
    posSalesByHour: "Ventas POS Por Hora",
    posSalesByHourReport: "Informe de Ventas POS Por Hora",
    posSalesByCategory: "Ventas POS Por Categoría",
    posSalesByCategoryReport: "Informe de Ventas POS Por Categoría",
    POSinventoryAndStock: "POS Inventario y Stock",
    POSinventoryAndStockReport: "POS Informe de Inventario y Stock",
    salesPerfomanceAndAnalysis: "Rendimiento de Ventas y Análisis",
    hospitalityAndServiceInteraction: "Hospitalidad e Interacción con el Servicio",
    transactionAndCashierManagement: "Gestión de Transacciones y Caja",
    inventoryAndOperationalManagement: "Gestión de Inventario y Operaciones",
    bottomSalesByArticleReport: "Laporan Penjualan Terendah Berdasarkan Artikel",
    posBottomSalesByArticle: "Laporan Penjualan Terendah POS Berdasarkan Artikel",
    reportName: "Nama Laporan",
    posInventoryAndStock: "Inventario y Stock POS",
    posInventoryAndStockReport: "Informe de Inventario y Stock de POS",
    salesPerformanceAndAnalysis: "Rendimiento y Análisis de Ventas",
    showAllTime: "Mostrar Todo el Tiempo",
    paymentTotal: "Total de pagos",
    totalIncludingTips: "Total con propinas",
    zReport: "Informe Z",
    xReport: "Informe X",
    cashier: "Cajero",
    posSalesByTableLabelReport: "Etiqueta de venta por mesa en POS",
    posSalesByTableLabel: "Informe de Ventas por Mesa en POS",
    salesSummaryByPackageReport: "Informe de Resumen de Ventas por Paquete",
    packageCode: "Código de paquete",
    packageName: "Nombre del paquete",
    packageRevenue: "Ingresos por Paquete",
    packageQuantity: "Cantidad de Paquete",
    avgPackagePrice: "Precio Promedio del Paquete",
    topPackage: "Paquete Superior",
    numberOfPackages: "# de Paquetes",
    averagePrice: "Precio Promedio",
    contributionPct: "% Contribución",
    contributionPctFromTotalRevenue: "Contribución % del ingreso total",
    packageBreakdown: "Desglose del paquete",
    posProductionByWaiter: "Producción de POS por Camarero",
    posProductionByWaiterReport: "Informe de Producción POS por Camarero",
    reportType: "Tipo de Informe",
    asOfDate: "Fecha de vigencia",
    customRange: "Rango Personalizado",
    quickSelect: "Selección Rápida",
    waiterCode: "Camarero",
    waiters: "Meseros",
    productionBreakdownFor: "Desglose de producción para {waiter} ({period})",
    unassigned: "No asignado",
    birSCDiscountReport: "Informe de Descuento para Personas Mayores BIR",
    birPWDDiscountReport: "Informe de Descuento BIR PWD",
    showFnbRevenue: "Mostrar Ingresos F&B",
    printPdfLandscape: "Imprimir PDF en Horizontal",
    showScPwdNames: "Mostrar Nombres de Personas Mayores/Con Discapacidad",
    creditMemoVoidReport: "Informe de Notas de Crédito / Anulaciones",
    documentType: "Tipo de Documento",
    documentTypeCreditMemo: "Nota de Crédito",
    documentTypeVoid: "Anulación",
    documentTypeBoth: "Ambos",
    type: "Tipo",
    originalInvoiceNo: "N.º de Factura Original",
    originalWorkingDate: "Fecha de Trabajo Original",
    voidReason: "Motivo de Anulación",
    posSalesByHourBreakdown: "Desglose de Ventas por Hora en TPV",
    breakdownTotal: "Total Desglose",
  },
  articleProductType: {
    discountRevenueCenter: "Centro de Ingresos por Descuento",
    perLineDiscountsWillUseTheSelectedRevenueCenter: "Los descuentos por línea usarán el centro de ingresos seleccionado",
    toEnableThisFeatureMakeSureDiscountAndAllowanceActiveInPOSParameter: "Para habilitar esta función, asegúrese de que la opción de Aplicar Descuentos y Bonificaciones esté activada en los parámetros del POS.",
  },
  guestProfile: {
    guestProfile: "Perfil de Invitado",
    successCreate: "¡Perfil de Invitado creado exitosamente!",
    successUpdate: "¡Perfil de Invitado actualizado exitosamente!",
    membership: "Membresía",
    membershipNumber: "Número de Membresía",
    cityNotes: "Ingresa al menos 3 caracteres para buscar una ciudad.",
    membershipType: "Tipo de Membresía",
    customerPIN: "PIN del Cliente",
    copyGuestFromFO: "¿Copiar Perfil de Invitado desde FO?",
    successCopy: "Perfil de Invitado copiado exitosamente",
    copyGuestProfile: "Copiar perfil de huésped",
    editGuestProfile: "Editar perfil de huésped",
    seeFOGuestList: "Ver lista de huéspedes de recepción",
    foGuestList: "Lista de huéspedes de recepción",
    saveGuestName: "Guardar nombre de perfil de invitado",
    posGuestProfile: "Perfil de Huésped POS",
    saveGuestProfileNameConfirmation: "Esto actualizará el nombre del perfil de invitado seleccionado, ¿estás seguro?",
    tinNumber: "TIN",
    scIdNumber: "ID de Adulto Mayor",
    pwdIdNumber: "ID de Persona con Discapacidad",
    signatureName: "Nombre de firma",
    isMembership: "Es Membresía",
  },
  contactPerson: {
    contactPerson: "Persona de Contacto",
    successCreate: "¡Persona de Contacto creada exitosamente!",
  },
  agency: {
    successCreate: "Agencia creada exitosamente",
    successUpdate: "Agencia actualizada exitosamente",
  },
  client: {
    successCreate: "Cliente creado exitosamente",
    successUpdate: "Cliente actualizado exitosamente",
  },
  clientComposition: {
    successCreate: "Composición de Cliente creada exitosamente",
    successUpdate: "Composición de Cliente actualizada exitosamente",
    warningChangeIsLedgerAllowed: "Necesitas permiso para cambiar \"¿Se permite Libro Mayor?\"",
    noLimit: "Sin Límite",
    setLimit: "Establecer Límite",
    currentAging: "Saldo Actual en Mora",
    todayLedger: "Libro Mayor de Hoy",
    totalUsedBalance: "Saldo Total Usado",
    availableCredit: "Crédito Disponible",
  },
  payment: {
    paymentTab: "Pago",
    tipTab: "Propina",
    tips: "Propinas",
    tipType: "Tipo",
    tipDescription: "Descripción",
    tipAmount: "Importe de propina",
    totalTip: "Total propina",
    noTips: "-- Sin propinas --",
    addTip: "Agregar propina",
    tipAmountMustBePositive: "El importe de la propina debe ser mayor que cero",
    cardNumber: "Número de tarjeta",
    cardName: "Nombre de la tarjeta",
    cardExpirationDate: "Fecha de caducidad de la tarjeta",
    cardTraceNumber: "Número de rastreo de la transacción",
    cardExpired: "Tarjeta caducada",
    invoiceAmountRemaining: "Importe restante de la factura",
    userPayment: "Pago del usuario",
    amountToPay: "Cantidad a pagar",
    change: "Cambio",
    remainingPayment: "Pago restante",
    titleHere: "Título aquí",
    amountToPayGreaterThanUserPayment: "La cantidad a pagar no puede ser mayor que el pago del usuario",
    amountToPayGreaterThanRemainingPayment: "La cantidad a pagar no puede ser mayor que el pago restante",
    cantCombinePayment: "No puedes combinar {payment} con otro tipo de pago",
    totalPaymentEqualInvoiceAmount: "El pago total ya es igual al importe de la factura. Elimina pagos para elegir otro método.",
    paymentIsNotReady: "¡La función de pago no está lista!",
    notAllowedToLedger: "{payment} no está permitido en el libro mayor",
    disabled: "{payment} deshabilitado",
    ledger: "Libro mayor",
    insufficientCredit: "Crédito insuficiente para el pago",
    differentClientPostingGroup: "Diferente Grupo de Publicación de Cliente con Cliente",
    ledgerForm: "Formulario de Libro Mayor",
    manualOrNumber: "Manual o número",
    manualOrNumberRequired: "El manual o número es obligatorio para pagos en efectivo o con tarjeta.",
    failedToSaveManualOrNumber: "No se pudo guardar el manual o número. Por favor, inténtelo de nuevo.",
    failedToPay: "Error al procesar el pago. El pedido se guardó pero la factura no se pagó. Inténtalo de nuevo.",
    availableBalance: "Saldo Disponible",
    collectionLimitExceededMessage: "Este pago excede el límite de crédito mensual disponible para la Identificación de Colección seleccionada. Por favor, utiliza otra Identificación de Colección con saldo disponible, o pide a un administrador que ajuste el Monto del Saldo de Crédito.",
    collectionLimitExceededTitle: "Límite de Identificación de Colección Excedido",
    creditLimit: "Límite de Crédito",
    invoiceAmount: "Importe de la Factura",
    overLimitAmount: "Cantidad Excedida",
    overLimitProcessedMessage: "La transacción se ha procesado con un monto excedido de {amount}",
    overLimitWarningMessage: "Este pago superará el límite de crédito mensual disponible para la Identificación de Colección seleccionada.",
    overLimitWarningTitle: "Advertencia de Límite Excedido",
    usedThisMonth: "Usado Este Mes",
  },
  screen: {
    new: "Nuevo",
    inProgress: "En preparación",
    ready: "Listo para servir",
    done: "Servido",
    table: "Mesa",
    orderNumber: "Pedido n.º",
    sentBy: "Enviado por",
    todaysFinishedOrders: "Órdenes terminadas de hoy",
    posScreenOrdersReport: "Informe de pedidos en pantalla POS",
    sinceOrderWasSent: "{minute} minuto desde que se envió el pedido | {minute} minutos desde que se envió el pedido",
    captainOrder: "Captain Order",
    printer: "Impresora",
    action: "Acción",
    reprintQuestion: "¿Reimprimir?",
    reprint: "Reimprimir",
    lastPrinted: "Última impresión",
    batch: "Lote",
    search: "Buscar",
    reprintAll: "Todos",
    reprintYes: "Sí",
    reprintNo: "No",
    popupBlocked: "La ventana emergente fue bloqueada. Permita las ventanas emergentes de este sitio para imprimir.",
    coReprint: "CO Reimpresión {count}",
    markAllReady: "Marcar todo listo",
    markSelectedReady: "Marcar selección lista ({count})",
  },
  localCommon: {
    dimensionSetup: "Configuración de Dimensiones",
    dimensionSetupSaved: "¡Configuración de dimensiones guardada correctamente!",
    dimensionSetupDeleted: "¡Configuración de dimensiones eliminada correctamente!",
    dashboardWithItem: "Tablero {item}",
    top10ItemsSoldWithItem: "Top 10 Artículos Vendidos - {item}",
    openDay: "Día de Puertas Abiertas",
    closeDay: "Cerrar Día",
    hostURLIPAddress: "URL del host / Dirección IP",
    roomRevenueBreakdown: "Desglose de Ingresos por Habitaciones",
    inHouseList: "Lista Interna",
    to: "Para",
    unknown: "Desconocido",
    customDate: "Fecha personalizada",
    itemLoan: "Préstamo de Artículo",
    maintenanceRequestReport: "Informe de Solicitud de Mantenimiento",
    printCancellationDocument: "Imprimir Documento de Cancelación",
    allowOverLimit: "Permitir Exceso",
    allowOverLimitDesc: "Si se habilita, las transacciones pueden exceder el saldo disponible.",
    allowOverLimitWarning: "Las transacciones que excedan el límite se procesarán igualmente y el sistema mostrará una notificación de exceso de límite.",
    collectionIdentification: "Identificación de Colección",
    continue: "Continuar",
    creditBalanceAmount: "Saldo de Crédito",
    creditBalanceAmountDesc: "Límite máximo de uso por mes.",
    creditBalancePositive: "La cantidad del saldo de crédito debe ser mayor que cero",
    critical: "Crítico",
    currentBalance: "Saldo Actual",
    currentBalanceDesc: "Límite restante aún disponible en el mes actual (calculado por el sistema).",
    limitExhausted: "Límite Agotado",
    monthlyCreditLimit: "Límite de Crédito Mensual",
    monthlyCreditLimitSubtitle: "El límite se aplica al mes actual según las transacciones registradas.",
    nearLimit: "Cerca del Límite",
    normal: "Normal",
    ok: "OK",
    overLimit: "Sobre Límite",
    totalUsedBalance: "Saldo Total Usado",
    totalUsedBalanceDesc: "Uso total en el mes actual (calculado por el sistema).",
    warning: "Advertencia",
  },
  $vuetify: {
    badge: "Insignia",
    close: "Cerrar",
    loading: "Cargando...",
    dataIterator: {
      noResultsText: "No se encontraron registros coincidentes",
      loadingText: "Cargando elementos...",
    },
    dataTable: {
      itemsPerPageText: "Filas por página:",
      ariaLabel: {
        sortDescending: "Ordenado de forma descendente.",
        sortAscending: "Ordenado ascendente.",
        sortNone: "No ordenado.",
        activateNone: "Activar para eliminar ordenación.",
        activateDescending: "Activar para ordenar de forma descendente.",
        activateAscending: "Activar para ordenar ascendente.",
      },
      sortBy: "Ordenar por",
    },
    dataFooter: {
      itemsPerPageText: "Elementos por página:",
      itemsPerPageAll: "Todo",
      nextPage: "Siguiente",
      prevPage: "Página anterior",
      firstPage: "Primera página",
      lastPage: "Última página",
      pageText: "{0}-{1} de {2}",
    },
    datePicker: {
      itemsSelected: "{0} seleccionado",
      nextMonthAriaLabel: "Próximo mes",
      nextYearAriaLabel: "El próximo año",
      prevMonthAriaLabel: "Mes anterior",
      prevYearAriaLabel: "Año anterior",
    },
    noDataText: "No hay datos disponibles",
    carousel: {
      prev: "Visual anterior",
      next: "Siguiente visual",
      ariaLabel: {
        delimiter: "Diapositiva {0} de {1}",
      },
    },
    calendar: {
      moreEvents: "{0} más",
    },
    fileInput: {
      counter: "{0} archivos",
      counterSize: "{0} archivos ({1} en total)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Navegación de Paginación",
        next: "Siguiente",
        previous: "Página anterior",
        page: "Ir a la página {0}",
        currentPage: "Página actual, Página {0}",
      },
    },
    input: {
      clear: "Limpiar",
      prependAction: "{0} acción antepuesta",
      appendAction: "{0} acción añadida",
    },
  },
  taxIntegrationLog: {
    decodeDocumentPayloadIntoJSON: "Decodificar carga del documento a JSON",
  },
  fbMenuConfiguration: {
    title: "Configuración del Menú F&B",
  },
  fbMenuOrderRequest: {
    def: "Solicitud de Pedido de Menú F&B",
    open: "Abrir Solicitud de Pedido de Menú F&B",
    closed: "Solicitud de Pedido de Menú F&B Cerrada",
    all: "Todas las Solicitudes de Pedido de Menú F&B",
    chooseTable: "Elegir Mesa",
    orderCreatedFromRequest: "Pedido creado a partir de solicitud de menú F&B",
    posMenuQRCode: "Código QR del Menú F&B del POS",
    guestRoomTable: "Mesa de Huésped",
    assignTable: "Asignar Mesa",
    currentlyOccupiedByGuestName: "actualmente ocupado por Nombre del Huésped",
    confirmOrderCancelTitle: "Cancelar Pedido",
    confirmOrderCancelBody: "¿Estás seguro de que quieres cancelar el pedido?",
    confirmUndoOrderCancelTitle: "Deshacer Cancelar Pedido",
    confirmUndoOrderCancelBody: "¿Estás seguro de que deseas deshacer la cancelación del pedido?",
    orderHasBeenCancelled: "Pedido cancelado",
    orderHasBeenUndoCancel: "El pedido ha sido restaurado",
    auditLog: {
      title: "Registro de Auditoría",
      guest: "Huésped",
      columns: {
        created: "Cuándo",
        type: "Acción",
        createdBy: "Por",
        description: "Descripción",
      },
      types: {
        CREATE: "Pedido Creado",
        ASSIGN_TABLE: "Mesa Asignada",
        CANCEL_BY_ADMIN: "Cancelado por Admin",
        UNDO_CANCEL: "Cancelación Deshecha",
      },
    },
    guestQR: "QR de Invitado",
    guestQRHint: "Muestra esto a tu invitado. El escaneo les permite pedir desde esta mesa directamente a la cuenta.",
    guestQRPrintPopupBlocked: "Se bloqueó el popup. Permita popups para este sitio para imprimir el QR.",
    guestQRPrintFailed: "No se pudo preparar el QR para imprimir.",
    scanMeToOrder: "ESCÁNAME PARA PEDIR",
    dynamicQRDisabled: "El QR dinámico está desactivado para este hotel",
  },
  package: {
    fieldRequired: "El campo es obligatorio",
    codeRequired: "El código es obligatorio",
    codeMaxLength: "El código no debe tener más de 10 caracteres",
    codeAlreadyUsed: "El código {code} ya está en uso.",
    saveSuccess: "{title} {code} ha sido {action}.",
    saveFailed: "No se pudo {action} {title} {code}.",
    actionSaved: "guardado",
    actionUpdated: "actualizado",
    confirmRemoveItems: "¿Seguro que quieres eliminar los elementos seleccionados?",
    deleteTitle: "Eliminar",
    deleteSuccess: "Los elementos se han eliminado.",
    deleteFailed: "No se pudieron eliminar los elementos seleccionados.",
    addOutletSuccess: "El establecimiento se ha agregado al paquete {code}.",
    addOutletFailed: "No se pudo agregar el establecimiento al paquete {code}.",
    addArticleSuccess: "El artículo se ha agregado al paquete {code}.",
    addArticleFailed: "No se pudo agregar el artículo al paquete {code}.",
    showPackageOrderDetailPriceMode: "Visibilidad del precio del detalle del pedido del paquete",
    showPackageDetailOnInvoice: "Mostrar detalle del paquete en la factura",
    packageOrderDetailPriceModeFollowParameter: "Seguir parámetro de POS",
    packageOrderDetailPriceModeForceShow: "Sobrescribir: Mostrar",
    packageOrderDetailPriceModeForceHide: "Sobrescribir: Ocultar",
    itemsLabel: "{count} elemento(s) seleccionado(s)",
    remove: "Eliminar",
    assignOutlet: "Asignar establecimiento",
    assignArticle: "Asignar artículo",
    saveBeforeManagingRelations: "Guarda el paquete antes de gestionar establecimientos o artículos.",
    emptyPreviewResponse: "La vista previa del paquete no devolvió contenido.",
    noArticlesInPreview: "El paquete no tiene artículos para agregar.",
  },
  tag: {
    title: "Etiquetas",
    tag: "Etiqueta",
    parent: "Padre",
    parents: "Padres",
    navigate: "Navegar",
    tagsNavigation: "Navegación de etiquetas",
    revenueCenterNotSet: "El artículo no tiene un centro de ingresos",
    submenu: "Submenú",
    home: "Inicio",
    menuHasNotBeenSetup: "El menú no ha sido configurado",
    removeNItems: "Eliminar {n} elemento(s)",
    nItems: "{n} artículos",
    seeArticleLocations: "Ver ubicaciones de artículos",
    articleLocations: "Ubicaciones de artículos",
    seeArticleGroups: "Ver grupos de artículos",
    seeMenuTags: "Ver etiquetas del menú",
  },
  tableLabelManagement: {
    accessibility: "Accesibilidad",
    addLabel: "Agregar Etiqueta",
    allCategories: "Todas las categorías",
    allowMultipleHint: "Al marcar, las tablas pueden tener múltiples etiquetas de esta categoría (p. ej., 'Vista al Océano' + 'Vista a la Piscina'). Al desmarcar, solo se permite una etiqueta (p. ej., 'Interior' o 'Exterior').",
    allowMultipleLabels: "Permitir múltiples etiquetas de esta categoría",
    allowMultipleSingleInfo: "Las categorías marcadas como 'Seleccionar Uno' permiten solo una etiqueta por tabla, mientras que las categorías 'Múltiples Permitidos' permiten asignar múltiples etiquetas de esa categoría.",
    appliedLabels: "Etiquetas Aplicadas",
    category: "Categoría",
    categoryDescriptionContent: "Las categorías agrupan etiquetas relacionadas. Por ejemplo, 'Ubicación Física' es una categoría que contiene etiquetas como Interior, Exterior, Patio, etc.",
    categoryDescriptionTitle: "¿Qué son las categorías?",
    categoryGroup: "Grupo de Categorías",
    categoryGroupHelp: "Agrupa categorías similares en la interfaz",
    categoryName: "Nombre de la categoría",
    chooseAColorThatMakesThisLabelEasyToIdentify: "Elige un color que haga fácil identificar esta etiqueta.",
    clearLabelsFilter: "Limpiar filtro de etiquetas",
    climateControl: "Control Climático",
    createNewCategory: "Crear nueva categoría",
    createNewCategoryDescription: "Añade una categoría de etiqueta personalizada para tus tablas",
    createNewLabel: "Crear nueva etiqueta",
    createNewLabelDescription: "Agrega una etiqueta personalizada para categorizar tus tablas",
    customLabels: "Etiquetas Personalizadas",
    description: "Descripción",
    editCategory: "Editar Categoría",
    editLabel: "Editar etiqueta",
    environment: "Entorno",
    examples: "Ejemplos",
    familyFeatures: "Características familiares",
    filterByLabels: "Filtrar por Etiquetas",
    guest: "Invitado",
    importSystemLabels: "Importar etiquetas del sistema",
    labelColor: "Color de etiqueta",
    labelDescriptionContent: "Las etiquetas son atributos específicos que puedes asignar a las tablas. Por ejemplo, dentro de la categoría 'Ubicación Física', podrías tener etiquetas como 'Interior', 'Exterior', 'Patio', etc.",
    labelDescriptionTitle: "¿Qué son las etiquetas?",
    labelName: "Nombre de la etiqueta",
    labels: "Etiquetas",
    labelsAreSpecificToEachOutlet: "Las etiquetas son específicas para cada punto de venta",
    labelsInUse: "Etiquetas en Uso",
    manageLabels: "Gestionar Etiquetas",
    managingLabelsFor: "Gestionando etiquetas para",
    modifyCategoryDescription: "Modificar la configuración de la categoría '{x}'",
    modifyLabelDescription: "Modificar la etiqueta '{x}'",
    multipleAllowed: "Múltiples Permitidos",
    multiSelectCategories: "Categorías de selección múltiple",
    newCategory: "Nueva Categoría",
    operational: "Operativo",
    ordersLast30d: "Pedidos (30D)",
    organizeAndCustomizeTableLabelsForYourOutlets: "Organiza y personaliza las etiquetas de las mesas para tus locales",
    outlets: "Locales",
    physicalLocation: "Ubicación Física",
    preview: "Vista previa",
    seating: "Asientos",
    seeLess: "Ver menos",
    selectionRules: "Reglas de Selección",
    selectOne: "Seleccionar Uno",
    service: "Servicio",
    singleSelectCategories: "Categorías de selección única",
    smokingPolicy: "Política de Fumar",
    sortOrder: "Orden de Clasificación",
    system: "Sistema",
    systemCategory: "Categoría del Sistema",
    systemCategoryMessage: "Esta es una categoría del sistema. Puedes modificar configuraciones como 'Permitir Múltiples' y 'Mostrar Grupo', pero el nombre de la categoría no se puede cambiar. Considera crear una categoría personalizada si necesitas un nombre diferente.",
    systemLabel: "Etiqueta del sistema",
    systemLabelMessage: "Esta es una etiqueta del sistema. Puedes modificar el color y otras configuraciones, pero el nombre de la etiqueta no se puede cambiar. Considera crear una etiqueta personalizada si necesitas un nombre diferente.",
    systemLabels: "Etiquetas del sistema",
    tableLabels: "Etiquetas de Tabla",
    tablesUsing: "Tablas Usando",
    thisCategoryAllowsMultipleLabelsPerTable: "Esta categoría permite múltiples etiquetas por tabla.",
    thisCategoryAllowsOnlyOneLabelPerTable: "Esta categoría permite solo una etiqueta por tabla.",
    tip: "Consejo",
    totalCategories: "Total de Categorías",
    totalLabels: "Total de Etiquetas",
    usageStatistics: "Estadísticas de Uso",
    usedByXTables: "Usado por {x} tablas",
    viewType: "Tipo de Vista",
    xLabels: "{x} etiquetas",
    xMore: "+{x} más",
    edcMachineIntegration: "Integración de Máquina EDC",
    enableEdcMachine: "Activar máquina EDC",
    edcMode: "Modo EDC",
    edcModeAlways: "Usar siempre EDC",
    edcModePrompt: "Solicitar al cajero que elija",
    edcAgentUrl: "URL del Agente Sentec",
    edcAgentUrlPlaceholder: "Dejar vacío para usar la URL de pos.agent",
    edcAgentUrlHint: "Vuelve a la URL de pos.agent si no está configurada",
    edcAgentToken: "Token de Agente Sentec",
    edcAgentTokenPlaceholder: "Dejar vacío para usar el token pos.agent",
    edcAgentTokenHint: "Sustituye el token pos.agent cuando se establece",
    edcVendor: "Proveedor EDC",
    edcComPort: "Puerto COM",
    edcComPortPlaceholder: "p. ej. COM3",
    edcTestConnection: "Probar conexión",
    edcConnected: "Conectado",
    edcFailed: "Fallido",
    edcEnterAgentUrlFirst: "Por favor, ingresa primero la URL del Agente Sentec.",
    edcPayment: "Pago EDC",
    edcInvoiceAmountRemaining: "Cantidad de factura restante",
    edcUserPayment: "Pago del usuario",
    edcTerminalWillReceive: "El terminal recibirá: {amount} ({currency} unidades menores)",
    edcChange: "Cambiar",
    edcRemainingPayment: "Pago restante",
    edcPressPayToInitiate: "Presiona Pagar para iniciar la transacción EDC",
    edcWaitingForCard: "Esperando tarjeta...",
    edcSecondsRemaining: "{seconds}s restantes",
    edcCancel: "Cancelar",
    edcTransactionApproved: "Transacción Aprobada",
    edcTransactionFailed: "Transacción Fallida",
    edcRetry: "Reintentar",
    edcPayViaEdc: "Pagar por EDC",
    edcConfirm: "Confirmar",
    edcCard: "Tarjeta",
    edcAuthCode: "Código de Autenticación",
    edcTraceNumber: "Rastro #",
    edcTerminal: "Terminal",
    edcTransactionDeclined: "Transacción rechazada",
    edcConnectionFailed: "Error al conectar con el terminal EDC",
    edcTotalPaymentAlreadyEqual: "Pago total ya igual al monto de la factura.",
  },
  orderNotification: {
    newOrderTitle: "Nuevo Pedido",
    newOrderMessage: "Nuevo pedido de {guest} en {outlet} ({location}) — {count} artículos, cantidad {qty}",
    orderCanceledMessage: "Pedido #{orderId} de {guest} en {outlet} ha sido cancelado",
    orderUndoCanceledMessage: "Pedido #{orderId} de {guest} en {outlet} cancelación ha sido revertida",
    orderAssignedToTableMessage: "Pedido #{orderId} de {guest} en {outlet} ha sido asignado a una mesa",
  },
  salesDocuments: {
    salesReturnTitle: "Devolución de Venta",
    salesRefundTitle: "Reembolso de Venta",
    reasonForRefund: "MOTIVO DEL REEMBOLSO: {value}",
    authorizer: "AUTORIZADOR: {value}",
    printSalesReturn: "Imprimir devolución de venta",
    printSalesRefund: "Imprimir reembolso de venta",
    billPrinterNotConfigured: "No hay impresora de cuenta configurada para este punto de venta.",
    printAgentNotConfigured: "No hay agente de impresión configurado para este dispositivo.",
  },
  eJournal: {
    typeSalesInvoice: "Factura de venta",
    typeAcknowledgementReceipt: "Recibo de reconocimiento",
    typeVoid: "Anulacion",
    typeCreditMemo: "Nota de credito",
    typeCancel: "Cancelacion",
    businessName: "Nombre del Negocio",
    period: "Periodo",
    createdBy: "Creado por",
    pdfSaved: "Se guardo {file} — {pages} pagina(s).",
    pdfUnsupportedChars: "El PDF no puede reproducir estos caracteres: {chars}. El archivo .txt descargado es la copia autoritativa.",
    title: "Diario Electronico BIR",
    dateFrom: "Desde",
    dateTo: "Hasta",
    lineWidth: "Ancho de linea",
    lineWidthAuto: "Vacío = según la configuración de impresión de cuenta de cada punto de venta",
    lineWidthRange: "Introduzca un número entero de {min} a {max}, o déjelo vacío para seguir la configuración de impresión de cuenta.",
    widthFromSetup: "{outlet}: {width} caracteres por línea, según la configuración de impresión de cuenta.",
    widthChosen: "{outlet}: {width} caracteres por línea, según lo elegido.",
    widthFromPrintSettings: "{outlet}: {width} caracteres por línea, según la configuración de impresión.",
    printSingleDayOnly: "La impresión en la impresora de cuentas es para un punto de venta y un día. Elija un solo punto de venta y la misma fecha en Desde y Hasta.",
    printSettingsTitle: "Configuración de impresión del E-Journal",
    printerTypeUnsupported: "El e-journal aún no se puede imprimir en {printer}: este tipo de impresora reajusta el texto y lo desalinearía. Elija otra impresora o use Imprimir como PDF.",
    generate: "Generar",
    downloadTxt: "Descargar .txt",
    allOutlets: "Todos los puntos de venta",
    noPermission: "No tiene permiso para ver el Diario Electronico BIR.",
    emptyState: "No se emitieron documentos fiscales para {outlet} entre {from} y {to}.",
    progress: "Generando {outlet} ({n} documentos)...",
    logTitle: "Registro de Ajustes POS",
    logNoPermission: "No tiene permiso para ver el Registro de Ajustes POS.",
    adjustmentType: "Tipo de ajuste",
    allTypes: "Todos los tipos",
    logDate: "Fecha de registro",
    orNo: "No. de OR",
    originalOrDate: "Fecha OR original",
    transactionNo: "No. de transaccion",
    cashier: "Cajero",
    approvedBy: "Aprobado por (operador)",
    grossAmount: "Importe bruto",
    vatAmount: "Importe IVA",
    netAmount: "Importe neto",
    paymentMethod: "Metodo de pago",
    reason: "Motivo",
    remarks: "Observaciones (derivadas)",
    derivedNote: "Las observaciones se derivan de la transaccion; Aprobado por muestra el operador que realizo el ajuste.",
    unresolvedDates: "{n} fila(s) no pudieron resolver la fecha OR original.",
    logEmptyState: "No se registraron ajustes para {outlet} entre {from} y {to}.",
  },
  tableLayout: {
    floorplanTooLarge: "El plano pesa {size} MB; el máximo es {max} MB",
    designerTitle: "Plano de mesas",
    publishToPos: "Mostrar este plano en el POS",
    pickAnOutlet: "Seleccione un punto de venta para diseñar su plano",
    loadOutletsFailed: "No se pudieron cargar los puntos de venta",
    loadTablesFailed: "No se pudieron cargar las mesas",
    saveFailed: "No se pudieron guardar {n} elemento(s)",
    saveSucceeded: "Plano guardado",
    floorplan: "Plano",
    unplaced: "Sin ubicar",
    allPlaced: "Todas las mesas ubicadas",
    shape: "Forma",
    shapeRectangle: "Rectángulo",
    shapeSquare: "Cuadrado",
    shapeCircle: "Círculo",
    shapeEllipse: "Elipse",
    shapeTriangle: "Triángulo",
    removeFromLayout: "Quitar del plano",
    selectATable: "Seleccione una mesa",
    blockingIssues: "{n} mesa(s) fuera del lienzo",
    overlapWarning: "{n} par(es) superpuesto(s)",
    layoutView: "Vista de plano",
    booked: "Reservada",
    nudge: "Desplazar",
    nudgeDown: "Desplazar 1 px abajo",
    nudgeLeft: "Desplazar 1 px a la izquierda",
    nudgeRight: "Desplazar 1 px a la derecha",
    nudgeUp: "Desplazar 1 px arriba",
  },
  waiterPin: {
    dialogTitle: "Se requiere PIN autorizado",
    pinLabel: "PIN del Supervisor",
    verify: "Verificar",
    invalidPin: "PIN inválido. Inténtalo de nuevo.",
    unauthorizedAction: "El usuario vinculado de este mesero no tiene permiso para realizar esta acción.",
    linkedUser: "Usuario vinculado",
    pinFieldLabel: "PIN",
    pinFieldHint: "PIN de 4 a 8 dígitos. Deja en blanco al editar para mantener el PIN actual.",
    associatedUserLabel: "Usuario Asociado",
    clearPinLabel: "Eliminar PIN actual",
    authorizedWaiter: "Mesero Autorizado",
    authorizedUser: "Usuario Autorizado",
    voidAuthorizedWaiter: "Cambrero Autorizado Nulo",
    voidAuthorizedUser: "Usuario Autorizado Anulado",
  },
  localVoidDocumentFilter: {
    showCreditMemoVoidOnly: "Mostrar solo nota de crédito / anulación",
    chooseMode: "Elegir qué pedidos de anulación / nota de crédito mostrar",
    reversalDocuments: "Documentos de reversión",
    originalOrders: "Pedidos originales",
    both: "Ambos",
    columnHeader: "Rol de anulación / nota de crédito",
    roleReversal: "Documento de reversión",
    roleOriginal: "Pedido original",
  },
};
